module.exports = __webpack_public_path__ + "img/image10.9ea95409.webp";